export default{
    computed: {
        baseUrl() {
            return process.env.VUE_APP_SANDKASTENLIGA_BASE_URL
        }
    }
}
